const isTestingEnvironment = () => {
  const hostname = window.location.hostname;
  return hostname.startsWith('staging') || hostname.startsWith('test') || hostname.startsWith('local');
};
export default isTestingEnvironment;
